import { Stack } from '@chakra-ui/react'
import MonthlyReportHeader from '../../../components/MonthlyReportHeader'
import usePurpleBubblesText from '../../../hooks/usePurpleBubblesText'
import PurpleBubbleContent from '../../../components/PurpleBubbleContent'
import MonthlyReportNavButtons from '../../../components/MonthlyReportNavButtons'
import useReportMonthGuard from '../../../hooks/useReportMonthGuard'
import { usePhysicalStrategiesFormState } from './hooks/usePhysicalStrategiesFormState'
import { PhysicalRegimens } from './components/PhysicalRegimens'
import { DentalRegimens } from './components/DentalRegimens'

export const PhysicalStrategiesPage = () => {
  const isValidated = useReportMonthGuard()
  const { handleSubmit, physicalLists, dentalLists } =
    usePhysicalStrategiesFormState()
  const purpleBubbleContent = usePurpleBubblesText('Step-10')
  const purpleBubbleContentDental = usePurpleBubblesText('Step-10-Dental')

  if (!isValidated) {
    return null // Don't render anything until month is validated
  }

  return (
    <Stack spacing={4}>
      <form onSubmit={handleSubmit}>
        <MonthlyReportHeader title='Physical Strategies' />
      </form>
      {purpleBubbleContent?.text && (
        <PurpleBubbleContent text={purpleBubbleContent.text} />
      )}
      <Stack spacing={10}>
        <PhysicalRegimens lists={physicalLists} />
        {purpleBubbleContentDental?.text && (
          <PurpleBubbleContent text={purpleBubbleContentDental.text} />
        )}
      </Stack>
      <DentalRegimens lists={dentalLists} />

      <form onSubmit={handleSubmit}>
        <MonthlyReportNavButtons />
      </form>
    </Stack>
  )
}
